import { Alert } from "antd";
import _ from "lodash";
import React from "react";
// import { useQuery } from 'react-apollo-hooks';
import Editor from "src/components/editor";
import Preview from "src/components/preview";
// import { APP_SETTING } from 'src/components/query/query';
import SketchStep from "src/components/sketchStep";

import { WrapBoxSection, WrapMainApp, WrapPreviewSection } from "./Main.styled";

const Main = (props) => {
  // const { data: appSetting } = useQuery(APP_SETTING);

  const arrParentsDay = ["20240503", "20240504", "20240507", "20240508"];

  const parentsDayMessage =
    "고객님께서 주문주신 케이크는 어버이날기간 배송제품으로 확인됩니다. 어버이날 기간제품은 물량이 많아 내부적으로 미리 검수를 마치기 때문에, 스케치를 최종 확정하시면 확정이후 절대로 수정이 불가능합니다. 따라서 반드시 신중하게 내용을 작성해주시고 디자인확정하기를 클릭해주시기 바랍니다.";

  return (
    <WrapMainApp>
      {!props.data.orderInfo.isAdmin && (
        <WrapBoxSection>
          <SketchStep />
        </WrapBoxSection>
      )}
      {props.data.orderInfo.isAdmin && (
        <Alert
          message="Sketch 관리자모드"
          type="info"
          showIcon={true}
          style={{ marginTop: "5px" }}
        />
      )}
      {_.findIndex(
        arrParentsDay,
        (curDay) => curDay === props.data.orderInfo.reserveDate
      ) !== -1 && (
        <Alert
          message="어버이날기간 특별공지"
          description={parentsDayMessage}
          type="warning"
          showIcon={true}
          style={{ marginTop: "5px" }}
        />
      )}
      <WrapPreviewSection>
        {props.data.orderInfo.productInfo.map((curProduct, idx) => {
          return (
            <Preview
              data={curProduct}
              key={curProduct.id + idx}
              orderInfo={props.data.orderInfo}
            />
          );
        })}
      </WrapPreviewSection>
      {_.findIndex(
        arrParentsDay,
        (curDay) => curDay === props.data.orderInfo.reserveDate
      ) !== -1 && (
        <Alert
          message="어버이날기간 특별공지"
          description={parentsDayMessage}
          type="warning"
          showIcon={true}
          style={{ marginTop: "5px" }}
        />
      )}
      <Editor />
    </WrapMainApp>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/containers/App/Main.tsx